var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopHeader'),_c('MenuStyle1'),_c('BannerStyle1'),_c('FeaturesStyle1'),_c('Services3Column'),_c('Speciality'),_c('Publish'),_c('PostsHome'),_c('Indexing'),_c('LetPublish'),_c('OurAffordablePricingPlans'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }